import BaseService from "./BaseService";
import http from "./HttpService";
import { API_BASE_URL_ENV } from "../jsx/common/common";

const apiEndpoint = API_BASE_URL_ENV() + "/staticPage";
const apiAboutEndpoint = API_BASE_URL_ENV() + "/staticPage/aboutUs";

export default class StaticPagesService extends BaseService {
	constructor() {
		super(apiEndpoint);
	}

	createAbout = (data) => {
		return http.post(apiAboutEndpoint, { ...data });
	};
	getAbout = () => {
		return http.get(apiAboutEndpoint);
	};
}
